import VueCookies from 'vue-cookies'

const TokenKey = 'token'

export function getToken() {
  return VueCookies.get(TokenKey)
}

export function setToken(token, expires = 2 * 60 * 60) {
  return VueCookies.set(TokenKey, token, expires)
}

export function removeToken() {
  return VueCookies.remove(TokenKey)
}
